import axiosInstance from '@/shared/api/axios';
import type {
  ApiStaffGetItem,
  ApiStaffListParams,
  ApiStaffListResponse,
  ApiStaffPostBody,
  ApiStaffPutBody,
  ApiStaffStatusPatchBody,
} from '@/shared/types/api/staff';

export const apiStaffListGet = async (
  params: ApiStaffListParams,
): Promise<ApiStaffListResponse> => {
  const { data } = await axiosInstance.get<ApiStaffListResponse>('/staffs', { params });
  return data;
};

export const apiStaffDetailGet = async (id: string): Promise<ApiStaffGetItem> => {
  const { data } = await axiosInstance.get<ApiStaffGetItem>(`/staffs/${id}`);
  return data;
};

export const apiStaffPost = async (body: ApiStaffPostBody): Promise<ApiStaffGetItem> => {
  const { data } = await axiosInstance.post<ApiStaffGetItem>('/staffs', body);
  return data;
};

export const apiStaffPut = async (
  id: string,
  body: ApiStaffPutBody,
): Promise<ApiStaffGetItem> => {
  const { data } = await axiosInstance.put<ApiStaffGetItem>(`/staffs/${id}`, body);
  return data;
};

export const apiStaffStatusPatch = async (
  id: string,
  body: ApiStaffStatusPatchBody,
): Promise<ApiStaffGetItem> => {
  const { data } = await axiosInstance.patch<ApiStaffGetItem>(`/staffs/${id}/status`, body);
  return data;
};

export const apiStaffDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/staffs/${id}`);
};
